module.exports = __webpack_public_path__ + "img/lucky_bk_c1.e72f30ea.png";